import React from 'react';
import "./onboard-two-buttons-style.scss";

const OnboardTwoButtons = (props) => {

    const {onClickLeft, onClickRight, leftLabel, rightLabel} = props;
    return (
        <div className="onboard-two-root">
            <button onClick={onClickLeft} className="onboard-two-buttons">{leftLabel}</button>
            <button onClick={onClickRight} className="onboard-two-buttons">{rightLabel}</button>
        </div>
    )
};

export default OnboardTwoButtons;
